import {
  FETCH_PROJECTS,
  FETCH_PROJECT_USERS,
  FETCH_PROJECT_DEVICES,
  FETCH_PROJECTS_STARTED
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  projects: [],
  status: statuses.idle
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_PROJECTS_STARTED:
      return { ...state, status: statuses.loading };
    case FETCH_PROJECTS:
      const projects = [...action.payload];
      if (projects[0]?.id === 1) {
        projects.parentId = 0;
      }
      return {
        ...state,
        projects,
        status: statuses.succeeded
      };
    case FETCH_PROJECT_USERS:
      return {
        ...state,
        projects: [
          ...state.projects.map(project => ({
            ...project,
            users: action.payload.filter(
              i => project.id === i.projectId
            )
          }))
        ]
      };
    case FETCH_PROJECT_DEVICES:
      return {
        ...state,
        projects: [
          ...state.projects.map(project => ({
            ...project,
            devices: action.payload.filter(
              i => project.id === i.projectId
            )
          }))
        ]
      };
    default:
      return state;
  }
};
